var _rect, _rect2, _rect3, _rect4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotorRound2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_412_20844)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 6,
    fill: "#7B8EFF"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_412_20844)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 6,
    fill: "#7B8EFF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-darker"
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 1.5,
    width: 36,
    height: 34.5,
    rx: 6,
    fill: "url(#paint0_linear_412_20844)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 34.5,
    width: 36,
    height: 1.5,
    rx: 0.75,
    fill: "url(#paint1_linear_412_20844)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_412_20844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1496 10.8501C14.0829 9.71681 13.9829 8.63348 13.8496 7.60015C14.6163 7.10015 15.9829 6.68348 17.9496 6.35015C18.6163 6.21681 19.2996 6.15015 19.9996 6.15015C24.4663 6.15015 26.4329 8.20015 25.8996 12.3001C25.4996 15.5335 23.3496 19.0335 19.4496 22.8001C18.4163 23.8001 17.4329 24.7001 16.4996 25.5001C17.6996 25.4668 18.9163 25.4168 20.1496 25.3501C21.4163 25.2835 22.8163 25.2501 24.3496 25.2501L23.7996 29.2501H10.5996L10.9996 25.9501C14.5329 22.7168 17.0163 20.1335 18.4496 18.2001C19.7829 16.4001 20.6163 14.7668 20.9496 13.3001C21.2163 11.0335 20.3496 9.90015 18.3496 9.90015C17.8163 9.90015 17.1663 9.98348 16.3996 10.1501C15.2663 10.3835 14.5163 10.6168 14.1496 10.8501Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_412_20844",
    x: 10.5996,
    y: 6.15015,
    width: 15.3848,
    height: 24.0368,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.936664
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_412_20844"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_412_20844",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_412_20844",
    x1: 18,
    y1: 1.5,
    x2: 18,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_412_20844",
    x1: 0,
    y1: 35.25,
    x2: 36,
    y2: 35.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.517013,
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_412_20844"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 6,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_412_20844"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotorRound2);
export default __webpack_public_path__ + "static/media/motor_round_2.3783d2eafabfa6b175b17d4a9d3cc51d.svg";
export { ForwardRef as ReactComponent };